import { Component, OnInit, AfterViewInit } from '@angular/core';

declare const lucide: any;

@Component({
  selector: 'app-indra',
  templateUrl: './indra.component.html',
  styleUrls: ['./indra.component.css']
})
export class IndraComponent implements OnInit, AfterViewInit {

  // Banner content
  bannerContent = {
    title: 'INDRA',
    subtitle: 'Intelligent Network for Defence Rations & Accommodation',
    description: 'Powering the Forces, Seamlessly. Secure, Smart, and \'Make in India\' Mess Management.'
  };

  // Key areas of automation
  keyAreas = [
    {
      icon: 'home',
      title: 'Accommodation',
      description: 'Comprehensive management of accommodation facilities and resources'
    },
    {
      icon: 'utensils',
      title: 'Catering',
      description: 'Streamlined catering operations and meal management systems'
    },
    {
      icon: 'wine',
      title: 'Wine',
      description: 'Specialized wine management and inventory control'
    },
    {
      icon: 'receipt',
      title: 'Billing',
      description: 'Automated billing and payment processing systems'
    },
    {
      icon: 'dollar-sign',
      title: 'Finance & Accounts',
      description: 'Complete financial management and accounting solutions'
    },
    {
      icon: 'settings',
      title: 'Administration',
      description: 'Administrative workflow and management tools'
    }
  ];

  // Core features and benefits
  coreFeatures = [
    {
      feature: 'Comprehensive Module Coverage',
      benefit: 'Manages all facets of a Mess: Accommodation, Catering, Wine, Billing, Finance, Accounts, and Administration.'
    },
    {
      feature: 'Offline Utility with Sync',
      benefit: 'Ensures continuity of operations for remote or deployed units (like ships) with Auto/Manual Sync capability.'
    },
    {
      feature: 'Unlimited Users',
      benefit: 'Scalable platform allowing unlimited users for Defence Organisations.'
    },
    {
      feature: 'Intuitive User Experience (UX)',
      benefit: 'Provides a Unique Intuitive User experience, simplifying complex management tasks.'
    },
    {
      feature: 'Electronic Workflows & Digital Signatures',
      benefit: 'Enables faster, paperless processing through Electronic Workflows and integration with Digital Signatures.'
    },
    {
      feature: 'Collaborative Platform',
      benefit: 'Designed to be Collaborative with Multiple Directorate users.'
    },
    {
      feature: 'Knowledge Base',
      benefit: 'Includes a Knowledge base with Document Management for easy access to critical information.'
    }
  ];

  // Technology highlights
  technologyHighlights = [
    {
      icon: 'flag',
      title: '100% Indian – Make In India',
      description: 'Proudly developed in India, supporting the nation\'s self-reliance goals'
    },
    {
      icon: 'shield',
      title: 'Part of EPPS Smart ERP Suite',
      description: 'Integrated with our comprehensive ERP ecosystem for seamless operations'
    },
    {
      icon: 'lock',
      title: 'No Third-Party Licensing',
      description: 'Cost-effective, open-source technology solutions with no external dependencies'
    },
    {
      icon: 'award',
      title: 'Military Grade Applications',
      description: 'Designed for mission-critical and highly sensitive military operations'
    }
  ];

  // Trust indicators
  trustIndicators = [
    {
      icon: 'calendar',
      title: 'Since 2008',
      description: 'Trusted partner of India\'s Defence Forces'
    },
    {
      icon: 'users',
      title: 'Proven Track Record',
      description: 'Successfully deployed across multiple defence establishments'
    },
    {
      icon: 'shield-check',
      title: 'Security First',
      description: 'Built with military-grade security standards'
    },
    {
      icon: 'heart',
      title: 'National Commitment',
      description: 'Dedicated to supporting India\'s defence capabilities'
    }
  ];

  constructor() { }

  ngOnInit(): void {
    // Initialize any required data or services
  }

  ngAfterViewInit(): void {
    this.initializeAnimations();
    this.initializeLucideIcons();
  }

  private initializeAnimations(): void {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
        }
      });
    }, observerOptions);

    // Observe all elements with data-animate attribute
    document.querySelectorAll('[data-animate]').forEach(el => {
      observer.observe(el);
    });
  }

  private initializeLucideIcons(): void {
    if (typeof lucide !== 'undefined') {
      lucide.createIcons();
    }
  }

}